






















































































import {defineComponent, ref, PropType, computed, watch } from "@vue/composition-api";
import * as AssetAPI from "@/services/api/assets";
import { getAssetTypes } from "@/psychlab/meta";
import { Asset, AssetPointer, AssetVersion } from "@/psychlab/types";
import { BrowseAssetModal } from "@/components.assets/browse-asset-modal";
import { AbsBox } from "@ui";
import { default as BlueprintUpdate } from "./blueprint-update.vue";

import { useAssets } from "@/hooks/useAssets";

export default defineComponent({
	emits:[ "input" ],
	props:{
		size:{
			type:String,
			default:"md"
		},
		value:{
			type:Object as PropType<AssetPointer<any>|null>,
			default:null
		},
		types:{
			type:Array as PropType<string[]>,
			default: () => []
		},
		modalTitle:{
			type:String,
			default:"Find Asset"
		},
		modalIcon:{
			type:String,
			default:"mdi.feature-search"
		},
		placeholder:{
			type:String,
			default:"Select Asset..."
		},
		// canUpdate:{
		// 	type:Boolean,
		// 	default:false,
		// },
		tag:{
			type:String,
			required:false,
		},
	},
	components:{
		BrowseAssetModal,
		AbsBox,
		BlueprintUpdate,
	},
	setup(props, context){

		const browseAssetModal = ref<any>("");
		const assetMissing = ref(false);
		const selectedAsset = ref<Asset>();


		const { refreshAsset } = useAssets();
		

		const versions = ref<AssetVersion<any>[]>([]);

		const label = computed(() => {
			if(assetMissing.value){ return "Asset missing or deleted"; }
			if(selectedAsset.value){
				return selectedAsset.value.name;
			}
			return "";
		});

		const canUpdate = computed(() => {
			return selectedAsset.value && selectedAsset.value.type === "Graph";
		});
		


		const icon = computed(() => {
			if(selectedAsset.value){
				const type = getAssetTypes().find(t => t.name === (selectedAsset.value as any).type);
				return type ? type.icon : "";
			}
			return "";
		});

		const activeVersion = computed(() => {
			if(!versions.value.length){ return null; }
			return versions.value.find(v => v._id === (props.value as any).ref.version);
		});

		const usingLatest = computed(() => {
			if(!activeVersion.value){ return false; }
			const max = Math.max(...versions.value.map(v => v.vIndex));
			return max === activeVersion.value.vIndex;
		});

		const handleUpdated = (v:AssetPointer<any>) => {
			context.emit("input", v);
			if(props.value && props.value.ref){
				refreshAsset(props.value.ref.asset)
			}
		};


		watch(() => props.value, () => refresh(), { deep:true });

		watch(() => props.value, (o, n) => {
			if(o && o.ref && n && n.ref){
				if(JSON.stringify(o.ref) === JSON.stringify(n.ref)){
					return;
				}
			}
			assetMissing.value = false;
		});

		const refresh = async() => {
			if(!props.value || !props.value.ref || assetMissing.value) { selectedAsset.value = undefined; return; }
			try{
				selectedAsset.value = await AssetAPI.getAsset(props.value.ref.asset);
				versions.value = await AssetAPI.loadVersionList(props.value.ref.asset);
			}catch(err){
				assetMissing.value = true;
			}
		};

		const findAsset = async() => {
			if(!props.types.length){ return; }
			const assetType = props.types[0];
			const value = props.value ? props.value.ref : null;
			const m = browseAssetModal.value;

			m.open({ value, assetType, tag:props.tag }, async(result:{ asset:string, version:string }) => {
				var { data } = await AssetAPI.getAssetVersion(result.asset, result.version, "data");
				var value = {
					ref:result,
					data
				};
				assetMissing.value = false;
				context.emit("input", value);
			});
		};

		refresh();

		return {
			usingLatest,
			browseAssetModal,
			assetMissing,
			selectedAsset,
			label,
			icon,
			activeVersion,
			findAsset,
			canUpdate,
			handleUpdated,
		};
	}


});

